module.exports = __webpack_public_path__ + "static/media/gaiAssistant.a7738432.png";